import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../common/WithAuth';
import ProductManagement from '../../pages/ProductManagement/ProductManagement';
import {
    getProductsByCompanyRequested, getProductsByCompanyClear, deleteProductRequested, deleteProductClear, updateProductOrderRequested, clearUpdateProductOrder,
} from '../../actions/ProductManagement';
import { GetDetailCompanyOrganizerRequested, ClearGetDetailCompanyOrganizer } from '../../actions/CompanyManagementOrganizer';
import DetailCompanyOrganizer from '../../selectors/DetailCompanyOrganizer';

const mapStateToProps = (state) => {
    const companyDetail = DetailCompanyOrganizer.createDetailCompanyOrganizerResultsSelector()(state);
    const isLoading = state.registrationOrganizer.registrationOrganizer.isFetching
    || state.companyManagementOrganizer.detailCompanyOrganizer.isFetching
    || state.productManagement.getList.isFetching
    || state.productManagement.delete.isFetching
    || state.productManagement.productOrder.isFetching;

    return {
        locale: state.locale.lang.current,
        companyID: state.auth.credential.data.company_id,
        companyDetail,
        eventInfo: state.registration.registrationViewer.data,
        productList: state.productManagement.getList.data,
        isLoading,
        successDelete: state.productManagement.delete.success,
        errorDelete: state.productManagement.delete.errors,
        updateOrderSuccess: state.productManagement.productOrder.success,
        updateOrderError: state.productManagement.productOrder.errors,
    };
};
const mapDispatchToProps = (dispatch) => ({
    fetchInfo: () => {
        dispatch(GetDetailCompanyOrganizerRequested());
    },
    clearInfo: () => {
        dispatch(ClearGetDetailCompanyOrganizer());
    },
    fetchList: (companyID, params) => dispatch(getProductsByCompanyRequested({ companyID, params })),
    clearList: () => dispatch(getProductsByCompanyClear()),
    deleteProduct: (companyID, productID) => dispatch(deleteProductRequested({ companyID, productID })),
    deleteProductClear: () => dispatch(deleteProductClear()),
    updateProductOrder: (companyID, objSeq) => dispatch(updateProductOrderRequested({companyID, objSeq})),
    clearUpdateProductOrder: () => dispatch(clearUpdateProductOrder()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ProductManagement);
